import React, { Fragment } from 'react';
import styles from './TinyWidgetsContent.module.scss';
import { TinyWidget } from '../TinyWidget/TinyWidget';
import { Divider } from '../../Divider/Divider';
import { MediaContext } from 'ui-smartforce-settings';

const PHONE_COLUMNS = 2;
const SMALL_COLUMNS = 3;

export interface TinyWidgetTotalsProps {
  title: string;
  value: number | string;
  isDisabled?: boolean;
  order?: number;
  getCustomFormattedValue?: (
    value: number | string
  ) => string | React.ReactElement;
}

export interface TinyWidgetsContentProps {
  totals: TinyWidgetTotalsProps[];
}

export const TinyWidgetsContent = ({
  totals
}: TinyWidgetsContentProps): React.ReactElement<TinyWidgetsContentProps> => {
  const { isPhone, isSmallScreen, isMediumScreen } =
    React.useContext(MediaContext);

  return (
    <div className={styles.tinyWidgetsContent}>
      {totals.map((widget, index) => {
        const isLastOfRow: boolean =
          !isMediumScreen &&
          ((isPhone &&
            index < totals.length - 1 &&
            (index + 1) % PHONE_COLUMNS === 0) ||
            (isSmallScreen &&
              index < totals.length - 1 &&
              (index + 1) % SMALL_COLUMNS === 0));

        return (
          <Fragment key={widget.title}>
            <TinyWidget
              className={`${styles.widget} ${
                index === totals.length - 1 || isLastOfRow
                  ? styles.noBorder
                  : ''
              }`}
              title={widget.title}
              value={widget.value}
              disabled={widget.isDisabled || false}
              getCustomFormattedValue={widget.getCustomFormattedValue}
            />

            {isLastOfRow && <Divider className={styles.horizontalDivider} />}
          </Fragment>
        );
      })}
    </div>
  );
};
